import Vue from 'vue'

Vue.component('quantity-selector', {
  props: {
    value: Number,
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 99
    }
  },
  data () {
    return {
      quantityValue: this.value
    }
  },
  methods: {
    incrementDown: function (e) {
      this.quantityValue = this.value - 1
      this.$emit('change', this.quantityValue)
    },
    incrementUp: function (e) {
      this.quantityValue = this.value + 1
      this.$emit('change', this.quantityValue)
    }
  },
  watch: {
    value: function () {
      if (this.value < this.min) {
        this.quantityValue = this.min
      } else if (this.value > this.max) {
        this.quantityValue = this.max
      }
    }
  },
  template: `
  <div class="quantity-selector">
    <button
      class="quantity-selector__action quantity-selector__action--decrement"
      type="button"
      v-on:click="incrementDown"
      :disabled="value <= min">
      <span class="quantity-selector__action__text"></span>
    </button>
    <p class="quantity-selector__field p1" v-html="quantityValue" />
    <button
      class="quantity-selector__action quantity-selector__action--increment"
      type="button"
      v-on:click="incrementUp"
      :disabled="value >= max">
      <span class="quantity-selector__action__text"></span>
    </button>
  </div>
  `
})
